import { useEffect } from 'react';
import type { MutableRefObject } from 'react';

interface UseSyncActiveSectionClassParams {
  activeSectionId: string | null;
  visibleSectionIds: string[];
  visibleSectionsRef: MutableRefObject<HTMLElement[]>;
}

export function useSyncActiveSectionClass({
  activeSectionId,
  visibleSectionIds,
  visibleSectionsRef,
}: UseSyncActiveSectionClassParams) {
  useEffect(() => {
    for (const section of visibleSectionsRef.current ?? []) {
      const active = section.classList.contains('active');
      const shouldBeActive = section.id === activeSectionId;

      if (active && !shouldBeActive) section.classList.remove('active');
      else if (!active && shouldBeActive) section.classList.add('active');
    }
  }, [activeSectionId, visibleSectionIds, visibleSectionsRef]);
}
